<script lang="ts">
	import ModalPrompt from '../ModalPrompt.svelte';
	import { format } from 'svelte-i18n';
	import { rebootDevice } from 'src/helpers/device_settings_helpers';
	import { rebootRequired } from 'src/stores/device-runtime/states';

	export let showModal = false;
</script>

{#if showModal}
	{@const props = {
		title: $format('reboot_device_title', { default: 'Reboot Device?' }),
		text: $format('rebooting_modal_prompt', {
			default:
				'Rebooting the device will restart its operating system. Are you sure you want to proceed?',
		}),
		button_1: $format('button_reboot_device', { default: 'Reboot device' }),
		button_2: $format('button_cancel'),
		callback: () => rebootDevice($rebootRequired),
	}}
	<ModalPrompt bind:showModal {props} />
{/if}
